import { db } from "@/firebase";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { doc, getDoc } from "firebase/firestore";

export const Route = createFileRoute("/clock/$shortCode/")({
  loader: async ({ params }) => {
    const { shortCode } = params;

    const snap = await getDoc(doc(db, "clockInShortCodes", shortCode));

    if (!snap.exists()) {
      throw notFound();
    }

    const { clockInId } = snap.data() as { clockInId: string };

    throw redirect({
      to: "/clock-in/$clockInId",
      params: { clockInId },
    });
  },
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground text-sm">Link not found or expired.</p>
    </div>
  ),
  component: () => null,
});
